import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerProductDetailsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { TirePartItem } from "./useSearchTiresByVehicle";

export const useGetTireByPartId = (
  swrOptions: SWRConfiguration<FetcherResult<TirePartItem>> = {}
): ModifiedSWRResponse<FetcherResult<TirePartItem>, TirePartItem> => {
  const route = useRouteParams(DealerProductDetailsRoute);

  const { data, ...result } = useSwrGet<TirePartItem>(
    route ? "/retailSiteWebService/parts/tire/getTireByPartId.php" : null,
    route
      ? {
          dealerId: route.dealerId,
          partId: route.partId,
          secondaryPartId: route.secondaryPartId || "null",
          vehicleId: route.vehicleId,
        }
      : {},
    swrOptions
  );

  return { ...result, data };
};
